export const FETCH_AREALIST_BEGIN = 'FETCH_AREALIST_BEGIN';
export const FETCH_AREALIST_SUCCESS = 'FETCH_AREALIST_SUCCESS';
export const FETCH_AREALIST_ERROR = 'FETCH_AREALIST_ERROR';

export const RESET_AREALIST = "RESET_AREALIST";